"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Loading = require("./Loading");

var _Loading2 = _interopRequireDefault(_Loading);

var _OrganicListing = require("./OrganicListing");

var _OrganicListing2 = _interopRequireDefault(_OrganicListing);

var _SiteTable = require("./SiteTable");

var _SiteTable2 = _interopRequireDefault(_SiteTable);

var _CommentArea = require("./CommentArea");

var _CommentArea2 = _interopRequireDefault(_CommentArea);

var _Markdown = require("./Markdown");

var _Markdown2 = _interopRequireDefault(_Markdown);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
//import ReactBody from "react-body";


var getProp = function getProp(listings, prop) {
  return listings && listings[0] && listings[0].allChildren && listings[0].allChildren.length === 1 && listings[0].allChildren[0] && listings[0].allChildren[0].data && listings[0].allChildren[0].data[prop];
};

var isArchived = function isArchived(listings) {
  return !!getProp(listings, "archived");
};
var flairClass = function flairClass(listings) {
  return getProp(listings, "link_flair_css_class");
};
var isLocked = function isLocked(listings) {
  return !!getProp(listings, "locked") || isArchived(listings);
};
var isCommentsPage = function isCommentsPage(listings) {
  return listings && listings[1];
};

var Content = function Content(_ref) {
  var _ref$OrganicListing = _ref.OrganicListing,
      OrganicListing = _ref$OrganicListing === undefined ? _OrganicListing2.default : _ref$OrganicListing,
      _ref$SiteTable = _ref.SiteTable,
      SiteTable = _ref$SiteTable === undefined ? _SiteTable2.default : _ref$SiteTable,
      _ref$CommentArea = _ref.CommentArea,
      CommentArea = _ref$CommentArea === undefined ? _CommentArea2.default : _ref$CommentArea,
      _ref$Loading = _ref.Loading,
      Loading = _ref$Loading === undefined ? _Loading2.default : _ref$Loading,
      _ref$Markdown = _ref.Markdown,
      Markdown = _ref$Markdown === undefined ? _Markdown2.default : _ref$Markdown,
      _ref$bodyClassName = _ref.bodyClassName,
      bodyClassName = _ref$bodyClassName === undefined ? "listing-page" : _ref$bodyClassName,
      isLoading = _ref.isLoading,
      listings = _ref.listings,
      props = _objectWithoutProperties(_ref, ["OrganicListing", "SiteTable", "CommentArea", "Loading", "Markdown", "bodyClassName", "isLoading", "listings"]);

  return isLoading ? _react2.default.createElement(Loading, null) : _react2.default.createElement(
    "div",
    { className: "content", role: "main" },
    isArchived(listings) && _react2.default.createElement(
      "div",
      { className: "reddit-infobar md-container-small with-icon archived-infobar" },
      _react2.default.createElement(
        "div",
        { className: "md" },
        _react2.default.createElement(
          "p",
          null,
          "This is an archived post. You won't be able to vote or comment."
        )
      )
    ),
    isLocked(listings) && !isArchived(listings) && _react2.default.createElement(
      "div",
      { className: "reddit-infobar md-container-small with-icon locked-infobar" },
      _react2.default.createElement(
        "div",
        { className: "md" },
        _react2.default.createElement(
          "p",
          null,
          "This post is locked. You won't be able to comment."
        )
      )
    ),
    (0, _util.optional)(OrganicListing, {}),
    _react2.default.createElement(
      "div",
      { className: "spacer" },
      listings && listings[0] && listings[0].content_md ? [_react2.default.createElement(Markdown, {
        key: "wiki-markdown",
        className: "wiki-page-content md-container",
        body: listings[0].content_md,
        html: listings[0].content_html
      })] : (listings || [])[0] ? (0, _util.optional)(SiteTable, _extends({
        className: "linklisting",
        expanded: !!listings[1],
        noNav: !!listings[1]
      }, props, listings[0])) : null,
      (listings || [])[1] ? (0, _util.optional)(CommentArea, _extends({}, props, { linkListing: listings[0] }, listings[1], { locked: isLocked(listings) })) : null
    )
  );
};

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/Content.js
// module id = 736
// module chunks = 0